import { AnimatePresence, motion } from 'framer-motion'
import React, { useState } from 'react'
import { displayImage } from '../../helpers/config';
import LinkButton from '../../ui/LinkButton';

function BigSaleContainer({ loading, data = {} }) {

    const [mainHover, setMainHover] = useState(false)
    const [imageLoading, setImageLoading] = useState(true)

    return (
        <div className="w-full relative overflow-hidden cursor-pointer"
            onMouseEnter={() => setMainHover(true)}
            onMouseLeave={() => setMainHover(false)}
        >

            {/* Image */}
            <div className="relative w-full overflow-hidden pt-[75%] rounded-lg md:pt-[56.25%]">
                <AnimatePresence>
                    {imageLoading && (
                        <div
                            className="absolute z-50 w-full h-full top-0 left-0 right-0 bottom-0 animate-pulse bg-gradient-to-r from-gray-50 to-white" />
                    )}
                </AnimatePresence>
                <motion.img
                    src={displayImage(data?.image)}
                    loading='lazy'
                    onLoad={() => setImageLoading(false)}
                    animate={{ scale: mainHover ? 1.1 : 1 }}
                    transition={{ duration: 0.2 }}
                    alt=""
                    className="absolute top-0 left-0 bottom-0 right-0 w-full h-full object-cover"
                />
            </div>

            {/* Description */}
            <div className="absolute top-0 p-5 sm:px-8 flex items-center h-full md:pr-40">
                <div>
                    <h4 className="text-sm font-medium">{data?.sub_title}</h4>
                    <h1 className="text-[clamp(1.8rem,2vw+1rem,2.4rem)] mt-2 sm:mt-4">{data?.title}</h1>
                    <p className="text-gray-600 text-xs sm:text-base mt-1 md:mt-3">
                        {data?.description}
                    </p>
                    <div className="mt-3 md:mt-5">
                        <LinkButton black to={data?.link_url}>{data?.link_name}</LinkButton>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BigSaleContainer